export default {
  title: 'Packaged',
  inspiViewerSource: 'https://d32ejwm21y7koy.cloudfront.net/viewer/',
  inspiViewerVersion: '2.5',
  }
  